export enum MenuITemAction {
    Read,
    Update,
    Delete,
    CreateChild,
    Duplicate,
    Reset,
    Desactivate,
    ActivateArchiving,
    Clone,
}
